// Eager import using import.meta.globEager
const importAllEager = (glob) => {
    const logos = {};
    for (const path in glob) {
        // Normalize the path to get the filename
        const name = path.split('/').pop();
        // Assign the module's default export directly
        logos[name] = glob[path].default;
    }
    return logos;
};

// Import all .png files from the logos directory eagerly
const logos = importAllEager(import.meta.glob('../assets/logos/*.png', { eager: true }));

// Bundled filenames mix cases ("si.png", "AA.png") while callers build keys from IATA/ICAO codes
// in whatever case the data has. The build is case-sensitive, so fall back to a case-insensitive
// lookup when the exact key is missing (an exact match always wins).
const lowerCaseIndex = {};
for (const name in logos) {
    lowerCaseIndex[name.toLowerCase()] = logos[name];
}

export default new Proxy(logos, {
    get(target, prop, receiver) {
        if (typeof prop === 'string' && !(prop in target)) {
            return lowerCaseIndex[prop.toLowerCase()];
        }
        return Reflect.get(target, prop, receiver);
    },
});